/**
 * The maximum value of `maximumFractionDigits`
 */
const MAX_FRACTION_DIGITS_LIMIT = 20;

export {MAX_FRACTION_DIGITS_LIMIT};
